export const debounce = <T>(func: (...args: T[]) => unknown, delay: number) => {
  let timer: NodeJS.Timeout;

  return function (...args: T[]) {
    clearTimeout(timer);
    timer = setTimeout(func, delay, ...args);
  };
};
